import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import CargoDocumentTypeTable from "../components/CargoDocumentTypeTable";
import { useCargoDocumentType } from "../../../apis/cargoDocumentType/CargoDocumentTypeProvider";
import { getPageName } from "../../../locales/translationUtils";
import { useTranslation } from 'react-i18next';
import NavBar, { NavBarItem } from "../../../components/NavBar";
import { GridColDef } from "@mui/x-data-grid";
import AlertOverlay from "../../../components/Alert";
import Paginacao from "../../../types/paginacao";
import { FaEdit } from "react-icons/fa";

const CargoDocumentTypeView: React.FC = () => {
    const { t } = useTranslation();
    const { cargosDocumentType, apiResponse, fetchCargoDocumentType, fetchCargoDocumentTypePaginated } = useCargoDocumentType();
    const navigate = useNavigate();
    const location = useLocation();
    const [alert, setAlert] = useState<{ message: string; variant: "success" | "danger" | "warning" | "info" } | null>(null);

    const [paginationModel, setPaginationModel] = React.useState({
            pageSize: 20,
            page: 0,
        });
    
        const [paginacao, setPaginacao] = React.useState({
            pageNum: 0,
            quantityPerPage: 20
        } as Paginacao);
        
        useEffect(() => {
            const newPaginacao = {
                ...paginacao, 
                pageNum: paginationModel.page,
                quantityPerPage: paginationModel.pageSize
            };
            setPaginacao(newPaginacao);
            fetchCargoDocumentTypePaginated(newPaginacao);
        }, [paginationModel]);

    useEffect(() => {
        if (location.state?.message) {
            setAlert({ message: location.state.message, variant: location.state.variant });
    
            navigate(location.pathname, { replace: true });
    
            const timeout = setTimeout(() => setAlert(null), 5000);
            return () => clearTimeout(timeout);
        }
    }, [location, navigate]);
     
    const navItems: NavBarItem[] = [
        { label: t('cargoDocumentType.labels.home'), route: "/", iconName: "house-door" },
        { label: t('cargoDocumentType.labels.new'), route: "/CargoDocumentType/create", iconName: "plus-circle" },
    ];

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: t('cargoDocumentType.fields.id'),
            width: 90,
            renderCell: (params) => (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "black",
                    cursor: "pointer"
                }}
                    onClick={() => navigate(`/cargoDocumentType/${params.row.id}`)}>
                    <FaEdit className="text-primary" style={{ marginRight: "6px", marginLeft: "2px"}}/>
                    {params.row.id}
                </span>
            ),
        },
        { field: "description", headerName: t('cargoDocumentType.fields.description'), width: 250 },
        { field: "key", headerName: t('cargoDocumentType.fields.key'), width: 250 },
    ];

    return (
    <Container fluid style={{ height: 'calc(100vh - 200px)', overflow: 'auto' }}>
        <NavBar items={navItems} />
            <div className="mb-3"></div>
            <h2>{getPageName("cargoDocumentType")}</h2>
            <div className="mb-3"></div>
            <div>
            {alert && (
                <AlertOverlay
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert(null)}
                />
            )}
        </div>
            <CargoDocumentTypeTable
                rows={cargosDocumentType || []}
                columns={columns}
                getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row")}
                apiResponse={apiResponse}
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
            />
        </Container>
    );
};

export default CargoDocumentTypeView;